import AppBar from '@mui/material/AppBar';
import Box from '@mui/material/Box';
import Toolbar from '@mui/material/Toolbar';
import Typography from '@mui/material/Typography';
import Place from '@mui/icons-material/Place';
import Container from '@mui/material/Container';

function Component() {
  return (
    <Box sx={{ flexGrow: 1 }}>
      <AppBar position="static">
        <Container>
          <Toolbar>
            <Place sx={{ marginRight: ".5rem" }} />
            <Typography variant="h6" component="div" sx={{ flexGrow: 1 }}>
              Chercher un code postal en Suisse
            </Typography>
          </Toolbar>
        </Container>
      </AppBar>
    </Box>
  );
}

export default Component;
